export var tabsTheme = {
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      overflowX: 'auto'
    },
    tabs: {
      display: 'flex',
      overflowX: {
        xs: 'auto',
        s: 'unset'
      }
    },
    tab: {
      display: 'flex',
      color: 'neutral.darker',
      cursor: 'pointer',
      textStyle: {
        xs: 'body3Semi',
        s: 'body2Semi'
      },
      borderBottom: 'selection.transparent',
      transition: '0.1s ease-in-out',
      transitionProperty: 'border, color',
      width: 'fit-content',
      padding: 's',
      paddingTop: {
        xs: 'xs',
        s: 's'
      },
      alignItems: 'center',
      outlineColor: 'focus.focus',
      outlineOffset: '-1px'
    },
    counters: {
      display: 'flex',
      gap: 'xxs',
      marginLeft: 'xxs'
    },
    badges: {
      display: 'flex',
      gap: 'xxs',
      marginLeft: 'xxs'
    }
  },
  variants: {
    default: {
      tab: {
        _hover: {
          color: 'brand.main'
        },
        _selected: {
          color: 'brand.main',
          borderBottom: 'selection.selectedBrand',
          outlineColor: 'focus.focus'
        },
        _active: {
          color: 'brand.dark'
        }
      }
    },
    neutral: {
      tab: {
        _hover: {
          color: 'neutral.darkest'
        },
        _selected: {
          color: 'neutral.black',
          borderBottom: 'selection.selectedNeutral',
          outlineColor: 'focus.focus'
        },
        _active: {
          color: 'neutral.black'
        }
      }
    }
  },
  defaultProps: {
    variant: 'default'
  }
};
//# sourceMappingURL=Tabs.theme.js.map